import { render, staticRenderFns } from "./EditablePlayableCreateVersion.vue?vue&type=template&id=728b2c28&lang=pug"
import script from "./EditablePlayableCreateVersion.vue?vue&type=script&lang=js"
export * from "./EditablePlayableCreateVersion.vue?vue&type=script&lang=js"
import style0 from "./EditablePlayableCreateVersion.vue?vue&type=style&index=0&id=728b2c28&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports